import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit, FiPrinter, FiTrash2, FiSettings } from 'react-icons/fi';

const Namuna9List = () => {
  const [filters, setFilters] = useState({
    ownerName: '',
    taxpayerName: '',
    propertyNumber: '',
    helperName: ''
  });
  
  const [listOrderBy, setListOrderBy] = useState('property');
  
  // Load data from localStorage
  const [tableData, setTableData] = useState([]);
  
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('namuna9Data') || '[]');
    setTableData(savedData);
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const handleQuickEdit = () => {
    alert('Quick Edit functionality');
  };

  const handleExportExcel = () => {
    alert('Export to Excel functionality');
  };

  const handleImportExcel = () => {
    alert('Import from Excel functionality');
  };

  const handleEdit = (id) => {
    console.log('Edit row:', id);
  };

  const handlePrint = (id) => {
    console.log('Print row:', id);
  };

  const handleDelete = (id) => {
    if (window.confirm('या नोंदी हटवायच्या आहेत का?')) {
      const updatedData = tableData.filter(item => item.id !== id);
      setTableData(updatedData);
      // Update localStorage
      localStorage.setItem('namuna9Data', JSON.stringify(updatedData));
    }
  };

  const handleSearch = () => {
    // Implement search logic here
    console.log('Searching with filters:', filters);
  };

  const handleClear = () => {
    setFilters({
      ownerName: '',
      taxpayerName: '',
      propertyNumber: '',
      helperName: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-700 to-blue-600 text-white p-4 rounded-t-lg shadow-md">
        <h1 className="text-xl font-bold">नमुना नं १ यादी</h1>
      </div>

      {/* Main Content */}
      <div className="bg-white shadow-lg rounded-b-lg">
        {/* Action Buttons */}
        <div className="bg-blue-500 text-white p-3 flex flex-wrap justify-between items-center gap-2">
          <Link 
            to="/Addnamuna9"
            className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded text-sm font-medium transition-colors"
          >
            नवीन नमुना न.९ नोदानी
          </Link>
          <div className="flex flex-wrap gap-2">
            <button 
              onClick={handleQuickEdit}
              className="bg-cyan-500 hover:bg-cyan-600 px-4 py-2 rounded text-sm font-medium transition-colors"
            >
              Quick Edit
            </button>
            <button 
              onClick={handleExportExcel}
              className="bg-cyan-500 hover:bg-cyan-600 px-4 py-2 rounded text-sm font-medium transition-colors"
            >
              Export Excel
            </button>
            <button 
              onClick={handleImportExcel}
              className="bg-cyan-500 hover:bg-cyan-600 px-4 py-2 rounded text-sm font-medium transition-colors"
            >
              Import Excel
            </button>
            <button className="bg-cyan-400 hover:bg-cyan-500 p-2 rounded transition-colors">
              <FiSettings size={20} />
            </button>
          </div>
        </div>

        {/* Filters Section */}
        <div className="p-6 bg-gray-50 border-b">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                मालकाचे नाव:
              </label>
              <input
                type="text"
                placeholder="निवडा..."
                value={filters.ownerName}
                onChange={(e) => handleFilterChange('ownerName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                भोगवटादाराचे नाव:
              </label>
              <input
                type="text"
                placeholder="निवडा..."
                value={filters.taxpayerName}
                onChange={(e) => handleFilterChange('taxpayerName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                मालमत्ता क्रं:
              </label>
              <input
                type="text"
                placeholder="निवडा..."
                value={filters.propertyNumber}
                onChange={(e) => handleFilterChange('propertyNumber', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                सहमिळकत धारकाचे नाव:  
              </label>
              <input
                type="text"
                placeholder="निवडा..."
                value={filters.helperName}
                onChange={(e) => handleFilterChange('helperName', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Total Count and Buttons */}
          <div className="flex flex-wrap items-center gap-4">
            <div className="text-lg font-semibold text-gray-800">
              एकूण नमुना नं: <span className="text-blue-600">{tableData.length}</span>
            </div>
            <button 
              onClick={handleSearch}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded text-sm font-medium transition-colors"
            >
              शोध
            </button>
            <button 
              onClick={handleClear}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded text-sm font-medium transition-colors"
            >
              साफ
            </button>
          </div>
        </div>

        {/* List Order By */}
        <div className="px-6 py-3 bg-white border-b">
          <div className="flex flex-wrap items-center gap-4">
            <span className="font-medium text-gray-700">List Order By</span>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="orderBy"
                value="property"
                checked={listOrderBy === 'property'}
                onChange={(e) => setListOrderBy(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <span className="text-sm">पावती नं</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="orderBy"
                value="date"
                checked={listOrderBy === 'date'}
                onChange={(e) => setListOrderBy(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <span className="text-sm">दिनांक नं</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="orderBy"
                value="alphabetical"
                checked={listOrderBy === 'alphabetical'}
                onChange={(e) => setListOrderBy(e.target.value)}
                className="w-4 h-4 text-blue-600"
              />
              <span className="text-sm">नावानुसार</span>
            </label>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 border-b">
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">क्रिया</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">अनुक्रमांक</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">तारीख</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">बिल क्र.</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">वॉर्डचे नाव</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">मालमत्ता क्रमांक</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">नाव</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">दर</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">प्रमाण</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">सूट</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">विक्री कर टक्केवारी</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">विक्री कर</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">अतिरिक्त शक्तिवाही</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">अतिरिक्त चालू</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">इतर शक्तिवाही</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">इतर चालू</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">सामान्य पाणीपुर्ती शक्तिवाही</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">सामान्य पाणीपुर्ती चालू</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">विशेष पाणीपुर्ती शक्तिवाही</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 border-r">विशेष पाणीपुर्ती चालू</th>
                <th className="px-4 py-3 text-sm text-right font-semibold">एकूण</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row) => (
                <tr key={row.id} className="border-b hover:bg-blue-50 transition-colors">
                  <td className="px-4 py-3 border-r">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(row.id)}
                        className="text-blue-600 hover:text-blue-800 transition-colors"
                        title="Edit"
                      >
                        <FiEdit size={18} />
                      </button>
                      <button
                        onClick={() => handlePrint(row.id)}
                        className="text-green-600 hover:text-green-800 transition-colors"
                        title="Print"
                      >
                        <FiPrinter size={18} />
                      </button>
                      <button
                        onClick={() => handleDelete(row.id)}
                        className="text-red-600 hover:text-red-800 transition-colors"
                        title="Delete"
                      >
                        <FiTrash2 size={18} />
                      </button>
                    </div>
                  </td>
                  <td className="px-4 py-3 border-r text-sm">{row.serialNo}</td>
                  <td className="px-4 py-3 border-r text-sm">{row.date}</td>
                  <td className="px-4 py-3 border-r text-sm">{row.billNo}</td>
                  <td className="px-4 py-3 border-r text-sm font-medium">{row.wordName}</td>
                  <td className="px-4 py-3 border-r text-sm">{row.propertyNo}</td>
                  <td className="px-4 py-3 border-r text-sm font-medium">{row.name}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.rate}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.quantity}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.discount}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.taxPercent}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.taxAmount}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.additionalPowerCurrent}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.additionalPowerCharge}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.otherPowerCurrent}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.otherPowerCharge}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.normalWaterPowerCurrent}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.normalWaterPowerCharge}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.specialWaterPowerCurrent}</td>
                  <td className="px-4 py-3 border-r text-sm text-right">{row.specialWaterPowerCharge}</td>
                  <td className="px-4 py-3 text-sm text-right font-semibold">{row.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {tableData.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            <p className="text-lg">कोणतीही नोंद आढळली नाही</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Namuna9List;